import type { AgentComponentToolOption } from '@reach/shared-types/agent-components';
import { X } from 'lucide-react';
import { TOOLS_FIELD_COPY } from './component-page-copy';
import styles from './AttachedToolItem.module.css';
import { toolLabel, toolRequestLabel } from './tool-option-labels';

interface AttachedToolItemProps {
  tool?: AgentComponentToolOption;
  onRemove: () => void;
}

/** A tool on the component. A tool missing from the active list was deactivated after it was added. */
export const AttachedToolItem = ({ tool, onRemove }: AttachedToolItemProps) => {
  const toolIsActive = tool !== undefined;
  const label = toolIsActive ? toolLabel(tool.displayName) : TOOLS_FIELD_COPY.inactiveTool;
  const details = toolIsActive ? toolRequestLabel(tool) : TOOLS_FIELD_COPY.inactiveToolDescription;

  return (
    <li className={styles.tool} data-active={toolIsActive}>
      <strong>{label}</strong>
      <p>{details}</p>
      <button type="button" onClick={onRemove} aria-label={TOOLS_FIELD_COPY.removeLabel(label)}>
        <X aria-hidden="true" />
      </button>
    </li>
  );
};
